(() => {
  const openDrawer = (opener = null) => {
    document.dispatchEvent(
      new CustomEvent('dispatch:cart-drawer:open', {
        detail: { opener },
      })
    );
  };

  const refreshDrawer = () => {
    document.dispatchEvent(
      new CustomEvent('dispatch:cart-drawer:refresh', {
        bubbles: true,
      })
    );
  };

  // 1) Când Symmetry confirmă că s-a adăugat în coș
  document.addEventListener('on:cart:add', (event) => {
    openDrawer();
    refreshDrawer();
  });

  // 2) Fallback global pentru orice /cart/add custom
  if (!window.__fastCartPatched) {
    const origFetch = window.fetch;
    window.fetch = function (...args) {
      try {
        const url =
          typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
        if (url.includes('/cart/add')) {
          openDrawer();
          return origFetch.apply(this, args).then((res) => {
            refreshDrawer();
            return res;
          });
        }
      } catch (e) {
        // dacă ceva crapă, mergem pe comportamentul normal
      }
      return origFetch.apply(this, args);
    };
    window.__fastCartPatched = true;
  }
})();
